export default __webpack_public_path__ + "static/media/Calibri-Light.bfc9611c.ttf";